import React, { useState } from "react";
import { Star } from "react-feather";
import ReactImageFallback from "react-image-fallback";
import { IIngredient } from "../../../interfaces/ingredient";
import { IProduct } from "../../../interfaces/products";
import config from "../../../utils/config";
import { getIngredientImagePlaceholder, getProductImagePlaceholder } from "../../../utils/ingredient";
import { ImageSkeleton } from "../../../utils/ghostUI";
import { truncate } from "../../../utils/string";

interface IProps {
	item: any;
	type: string;
	onClick: () => void;
	starred?: boolean;
}
const RecentItem: React.FC<IProps> = (props) => {
	const [imageError, setImageError] = useState(false);
	const [imageLoading, setImageLoading] = useState(true);

	const handleImageError = () => {
		setImageError(true);
		setImageLoading(false);
		
	};

	const handleImageLoad = () => {
		setImageLoading(false);
		
	};

	const getImageSrc = () => {
		if (props.type === "ingredients") {
			// For ingredients, check if there's an image_uri, otherwise use fallback directly
			// Don't try the API endpoint as it may return old placeholder
			return props.item.image_uri && props.item.image_uri !== "" 
				? props.item.image_uri 
				: null;
		} else {
			// If image_uri is empty or missing, return null to trigger fallback
			const src = props.item.image_uri && props.item.image_uri !== "" ? props.item.image_uri : null;
			
			return src;
		}
	};

	const getFallbackImage = () => {
		if (props.type === "ingredients") {
			return getIngredientImagePlaceholder();
		} else {
			const fallback = getProductImagePlaceholder();
			
			return fallback;
		}
	};

	return (
		<div className={"recent-item"} onClick={props.onClick}>
			{props.starred ? (
				<div className="starred">
					<Star size={28} />
				</div>
			) : (
				<></>
			)}
			{imageLoading && <ImageSkeleton className="recent-img-slider-ghost" />}
			{getImageSrc() ? (
				<img
					src={imageError ? getFallbackImage() : getImageSrc()}
					alt={props.type === "ingredients" ? "Ingredient Image" : "Product Image"}
					onError={handleImageError}
					onLoad={handleImageLoad}
					style={{ display: imageLoading ? 'none' : 'block' }}
				/>
			) : (
				<img
					src={getFallbackImage()}
					alt={props.type === "ingredients" ? "Ingredient Image" : "Product Image"}
					onLoad={handleImageLoad}
					style={{ display: imageLoading ? 'none' : 'block' }}
				/>
			)}
			{props?.item?.jf_display_name?.length > 12 || props.item.name?.length > 12 ? (
				<div data-tooltip={props.item.jf_display_name}>
					<h5>
						{props.type == "ingredients"
							? truncate(props.item.jf_display_name, 12)
							: truncate(props.item.name, 12)}
					</h5>
				</div>
			) : (
				<h5>
					{props.type == "ingredients"
						? truncate(props.item.jf_display_name, 12)
						: truncate(props.item.name, 12)}
				</h5>
			)}
		</div>
	);
};

export default RecentItem;
